import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">实时追踪最新黑料吃瓜快讯</p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-secondary-200 hidden sm:block"></div>
          <div className="space-y-4">
            {updatesData.map((item, index) => (
              <button
                key={item.id}
                onClick={() => handleScroll('#cards')}
                className="w-full flex items-start gap-5 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer text-left group"
              >
                <div className="hidden sm:flex flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 items-center justify-center mt-0.5">
                  <span className="text-xs font-bold text-primary-600">{index + 1}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    {item.tag && (
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '热议' ? 'bg-accent-100 text-accent-800' :
                        'bg-secondary-200 text-foreground-600'
                      }`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}